import { getBoxTypes } from "./boxes.js";
/**
 * Computes the cube utilization based on the specified boxes, occupancies and constraint by the specified features.
 * @param boxes The list of boxes
 * @param occupancies The current occupancies
 * @param features The requested features
 */
export function computeCubeUtilization(boxes, occupancies, features = []) {
    boxes = boxes.filter(box => hasFeatures(box, features));
    return {
        all: computeUtilization(boxes, occupancies),
        types: computeBoxTypes(features.length < 1 ? boxes.filter(b => !b.accessible && !b.cooled && !b.dangerousGoods) : boxes, occupancies),
        cooled: computeBoxTypes(boxes.filter(b => b.cooled), occupancies),
        accessible: computeBoxTypes(boxes.filter(b => b.accessible), occupancies),
        dangerousGoods: computeBoxTypes(boxes.filter(b => b.dangerousGoods), occupancies),
        charger: computeBoxTypes(boxes.filter(b => b.charger), occupancies),
    };
}
function hasFeatures(box, features) {
    return features.every(feature => box[feature]);
}
function computeBoxTypes(boxes, occupancies) {
    return getBoxTypes(boxes).reduce((acc, type) => computeType(acc, type, boxes, occupancies), {});
}
function computeType(acc, type, boxes, occupancies) {
    acc[type] = computeUtilization(boxes.filter(box => box.types.indexOf(type) >= 0), occupancies);
    return acc;
}
export function computeUtilization(boxes, occupancies) {
    const available = boxes.filter(box => { var _a; return !box.disabled && !box.maintenanceRequiredAt && occupancies.filter(occupancy => occupancy.boxNumber == box.number).length < ((_a = box.maxOccupancies) !== null && _a !== void 0 ? _a : 1); }).length;
    const occupied = boxes.filter(box => occupancies.find(occupancy => occupancy.boxNumber == box.number)).length;
    const disabled = boxes.filter(box => box.disabled || box.maintenanceRequiredAt).length;
    return {
        available,
        occupied,
        disabled,
        total: boxes.length,
    };
}
//# sourceMappingURL=utilization.js.map